import { Component, ElementRef, Input, OnInit, OnDestroy, HostListener } from '@angular/core';
import { DragModalService } from './modal-draggable.service';
import { DragModalOption } from './modal-draggable.class';
import * as _jquery from 'jquery';
const $: JQueryStatic = _jquery;

@Component({
  // tslint:disable-next-line: component-selector
  selector: 'q-dragmodal',
  templateUrl: './modal-draggable.component.html',
  styleUrls: ['./modal-draggable.component.css']
})

export class DragModalComponent implements OnInit, OnDestroy {
  private element: JQuery;

  modalTitle: string = 'TEST';
  showDragButtons: boolean = false;
  isopen: boolean = true;
  idDragDiv: string = 'dragdiv';
  idDragDivHeader: string = 'dragdivheader';
  idDragBtns: string = 'dragdtns';

  @Input('id') id: string = `dragdiv`;
  @Input('options') options: DragModalOption | null;

  @HostListener('window:resize', ['$event'])
  onResize(event?: Event): any { this.setIsMobile(); }

  constructor(private modalService: DragModalService, private el: ElementRef) {
    this.element = $(el.nativeElement);
  }

  ngOnInit(): void {
    this.setIsMobile();

    // check if modal id is defined
    if (!this.id || this.id === '') {
      console.error('modal must have an id');
      alert('modal must have an id');
      return;
    }
    // check if the modal id is dublec in the modal collection managed by the service
    //if (this.modalService.isDoubled(this.id)) {
    //  console.error(`two modals with the same id ${this.id}`);
    //  alert(`two modals with the same id ${this.id}`);
    //  return;
    //}
    // set modal options
    if (this.options) {
      this.modalTitle = this.options.title;
      this.showDragButtons = this.options.showDragButtons;
    }
    // set modal inner div ids
    this.idDragDiv += `_${this.id}`;
    this.idDragDivHeader += `_${this.id}`;
    this.idDragBtns += `_${this.id}`;

    // move element to bottom of page (just before </body>) so it can be displayed above everything else
    this.element.appendTo('body');
    this.element.hide();

    // add self (this modal instance) to the modal service so it's accessible from controllers
    this.modalService.add(this);

    setTimeout(() => { this.InitDrag(); }, 100);
  }

  // remove self from modal service when directive is destroyed
  ngOnDestroy(): void {
    this.modalService.remove(this.id);
    this.element.remove();
  }

  // open modal
  open(): void {
    //this.InitDrag();
    if (!this.setIsMobile()) {
      if (!this.isopen) {
        this.isopen = true;
        $(`#${this.idDragDiv}`).show();
      }

      this.element.show();
      $('body').addClass('modal-open');
    }
  }

  // close modal
  close(): void {
    this.element.hide();
    $('body').removeClass('modal-open');
  }

  // hide/show draggable div
  settingDiv(): void {
    //$(`#${this.idDragDiv}`)
    if ($(`#${this.idDragDiv}`).length > 0) {
      if (this.isopen)
        $(`#${this.idDragDiv}`).hide(500);
      else
        $(`#${this.idDragDiv}`).show(500);

      this.isopen = !this.isopen;
    }
  }

  private InitDrag(): void {
    if ($(`#${this.idDragDiv}`).length > 0) {
      const div: HTMLElement = $(`#${this.idDragDiv}`)[0];
      const divHeader: HTMLElement | null = $(`#${this.idDragDivHeader}`).length > 0 ? $(`#${this.idDragDivHeader}`)[0] : null;
      const divBtns: HTMLElement | null = $(`#${this.idDragBtns}`).length > 0 ? $(`#${this.idDragBtns}`)[0] : null;
      const index: number = this.modalService.getIndex(this.id);

      // dragdiv top and left defined in css are 50%, we increase for each new drag-modal
      const margin: number = 50 + index;
      $(div).css('top', `${margin}%`);
      $(div).css('left', `${margin}%`);
      if (divHeader) {
        $(divHeader).css('color', this.getColor(index));
        $(divHeader).css('border-bottom-color', this.getColor(index));
      }
      if (divBtns) {
        // buttonsdiv top defined in css is 150px, we increase for each new drag-modal
        const marginBtn: number = 150 + (49 * index); // 49 is the btns height + 5 of margin
        $(divBtns).css('top', `${marginBtn}px`);
        $(`#${divBtns.id} button`).css('color', this.getColor(index));
      }

      this.dragElement(div, divHeader);
    }
    else
      console.error('impossible to init draggable div');
  }

  private dragElement(mainDiv: HTMLElement, headerDiv: HTMLElement | null): void {
    let pos1: number = 0;
    let pos2: number = 0;
    let pos3: number = 0;
    let pos4: number = 0;

    let dragMouseDown: (e: any) => void;
    dragMouseDown = function (e: any): void {
      const windowEvents: any = $(window).data('events') || {};
      e = e || windowEvents;
      e.preventDefault();
      // get the mouse cursor position at startup:
      pos3 = e.clientX;
      pos4 = e.clientY;
      document.onmouseup = closeDragElement;
      // call a function whenever the cursor moves:
      document.onmousemove = elementDrag;
    };

    let elementDrag: (e: any) => void;
    elementDrag = function (e: any): void {
      const windowEvents: any = $(window).data('events') || {};
      e = e || windowEvents;
      e.preventDefault();
      // calculate the new cursor position:
      pos1 = pos3 - e.clientX;
      pos2 = pos4 - e.clientY;
      pos3 = e.clientX;
      pos4 = e.clientY;
      // set the element's new position:
      mainDiv.style.top = (mainDiv.offsetTop - pos2) + 'px';
      mainDiv.style.left = (mainDiv.offsetLeft - pos1) + 'px';
    };

    let closeDragElement: () => void;
    closeDragElement = function (): void {
      /* stop moving when mouse button is released:*/
      document.onmouseup = null;
      document.onmousemove = null;
    };

    if (headerDiv) {
      /* if present, the header is where you move the DIV from:*/
      //document.getElementById(elmnt.id + "header").onmousedown = dragMouseDown;
      headerDiv.onmousedown = dragMouseDown;
    } else {
      /* otherwise, move the DIV from anywhere inside the DIV:*/
      mainDiv.onmousedown = dragMouseDown;
    }
  }

  private setIsMobile(): boolean {
    const winW: number | undefined = $(window).width();
    const isMobile: boolean = winW && winW <= 768 ? true : false;
    if (isMobile)
      this.close();
    return isMobile;
  }

  private getColor(index: number): string {
    switch (index) {
      case 1: return '#32a852'; // green
      case 2: return '#a8323e'; // red
      case 3: return '#4e32a8'; // blue
      case 4: return '#94a32f'; // yellow
      default: return '#8a30a1'; // violet
    }
  }
}
